<template>
  <div class="wrap1">
    <h2 class="common-title">
      <i class="el-icon-arrow-left back" @click="handlerBack"></i>
      {{ detail.title }}
    </h2>
    <div class="wrap1-content">
      <el-form :inline="true" :model="formData" class="demo-form-inline">
        <!-- 文件类型 -->
        <el-form-item :label="$t('certificate_staff_17')">
          <el-select v-model="detail.query.certificate_state" clearable :placeholder="$t('221')">
            <el-option :label="$t('certificate_staff_1')" value="1" />
            <el-option :label="$t('certificate_staff_3')" value="2" />
            <el-option :label="$t('certificate_staff_5')" value="3" />
            <el-option :label="$t('certificate_module_15')" value="4" />
          </el-select>
        </el-form-item>
        <!-- 员工信息 -->
        <el-form-item :label="$t('pay.slip.2')">
          <staff-search
            ref="staff"
            class="search-input"
            comment="comment"
            size="small"
            @change="staff_id => staffChange(staff_id, 'staff_id')"
          />
        </el-form-item>
        <!-- 申请人/操作人 -->
        <el-form-item :label="$t('certificate_staff_25')">
          <staff-search
            ref="operate"
            class="search-input"
            comment="comment"
            size="small"
            @change="staff_id => staffChange(staff_id, 'operate_id')"
          />
        </el-form-item>
        <!-- 文件状态 -->
        <el-form-item :label="$t('certificate_staff_24')">
          <el-select v-model="detail.query.type" multiple clearable :placeholder="$t('221')">
            <el-option :label="$t('pay_slip_20')" value="1" />
            <el-option :label="$t('certificate_module_10')" value="2" />
          </el-select>
        </el-form-item>
        <!-- 发送时间 -->
        <el-form-item :label="$t('206')">
          <el-date-picker
            v-model="sendDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            :range-separator="$t('409')"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            @change="sendDateChange"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 确定 -->
        <el-button v-show="selectData.check" :loading="selectLoa" size="small" @click="clickSelect" type="primary">{{
          selectData.check
        }}</el-button>
        <!-- 重置 -->
        <el-button v-show="selectData.reset" :loading="deleteLoa" size="small" @click="clickReset">{{
          selectData.reset
        }}</el-button>
      </el-form>
      <el-table :data="tableData" :height="tableHeight" style="width: 100%" v-load="loading">
        <el-table-column
          v-for="item in detail.table"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          :align="item.align"
          :key="item.label"
          :fixed="item.fixed"
        >
          <template slot-scope="scope">
            <template v-if="item.type === 'operation'">
              <el-button type="text" @click="clickView(scope.row)" v-show="item.list.view">
                {{ item.list.view }}
              </el-button>
            </template>
            <template v-else>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <Pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        :current-page="detail.query.page"
        :page-size="detail.query.page_size"
        :page-sizes="page.pageSizes"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { detailData } from '../component/config.js'
import staffSearch from '_c/staff-search'
import Pagination from '_c/pagination'
export default {
  components: { staffSearch, Pagination },
  data() {
    return {
      params: this.$route.params,
      query: this.$route.query,
      detailData,
      formData: {},
      sendDate: '',
      page: {
        pageSizes: [20, 50, 100],
        total: 0
      },
      deleteLoa: false,
      loading: false,
      selectLoa: false,
      row: {},
      tableData: []
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 118
    },
    detail() {
      return this.detailData[6]
    },
    selectData() {
      return this.detail.selectData
    }
  },
  created() {
    this.getHistoryList(1)
    this.$route.meta.title = this.detail.title
  },
  methods: {
    // 返回列表页
    handlerBack() {
      this.$router.push({ path: this.selectData.goPath })
    },
    // 选择员工信息
    staffChange(val, item) {
      this.detail.query[item] = val.staff_id
    },
    sendDateChange(v) {
      if (v) {
        const [start, end] = v
        this.detail.query.start_time = start
        this.detail.query.end_time = end
      } else {
        this.detail.query.start_time = ''
        this.detail.query.end_time = ''
      }
    },
    clickSelect() {
      this.selectLoa = true
      this.getHistoryList(1)
    },
    // 获取列表
    getHistoryList(page) {
      this.detail.query.page = page
      const { api } = this.detail
      this.loading = true
      api
        .listData(this.detail.query)
        .then(res => {
          this.tableData = res.data.list
          this.page.total = res.data.page_data.total
        })
        .finally(() => {
          this.loading = false
          this.deleteLoa = false
          this.selectLoa = false
        })
    },
    handleCurrentChange(page) {
      this.getHistoryList(page)
    },
    handleSizeChange(size) {
      this.detail.query.page_size = size
      this.getHistoryList(1)
    },
    // 重置
    clickReset() {
      this.$refs.staff.res = {}
      this.$refs.staff.supOptions = []
      this.$refs.operate.res = {}
      this.$refs.operate.supOptions = []
      this.detail.query.certificate_state = ''
      this.detail.query.staff_id = ''
      this.detail.query.operate_id = ''
      this.detail.query.start_time = ''
      this.detail.query.end_time = ''
      this.detail.query.type = []
      this.detail.query.page = 1
      this.detail.query.page_size = 100
      this.deleteLoa = true
      this.getHistoryList(1)
    },
    // 查看
    clickView(row) {
      const object_url = row.oss_link[0] ? row.oss_link[0].object_url : row.oss_link.object_url
      window.open(object_url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  &-content {
    background: #fff;
    padding: 24px 24px 0;
    padding-bottom: 15px;
    /deep/ .el-date-editor {
      .el-range-separator {
        padding: 0;
      }
    }
  }
}
.back {
  cursor: pointer;
}
</style>
